import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  IconButton,
  Collapse,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import NodeCard from "./NodeCard";
import {
  NodeSchedule,
  RichSession,
} from "../../../redux/reducers/scheduleReducer";

interface Props {
  type: string;
  nodes: NodeSchedule[];
  selectedNodeId: string | null;
  onSelectNode: (node: NodeSchedule) => void;
  onSelectSession: (session: RichSession) => void;
  selectedSession?: RichSession | null;
  drawerOpen?: boolean;
}

const NodeTypeSection: React.FC<Props> = ({
  type,
  nodes,
  selectedNodeId,
  onSelectNode,
  onSelectSession,
  selectedSession,
  drawerOpen = false,
}) => {
  const [expanded, setExpanded] = useState(type === "AWS_ASG_INSTANCE");

  return (
    <Paper elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          cursor: "pointer",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant="h6" sx={{ fontSize: "1.1rem", fontWeight: 500 }}>
          {type.replace(/_/g, " ")} ({nodes.length})
        </Typography>
        <IconButton size="small" onClick={(e) => {
          e.stopPropagation();
          setExpanded(!expanded);
        }}>
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      
      <Collapse in={expanded}>
        <Box sx={{ p: 2, pt: 0 }}>
          <Grid container spacing={2}>
            {nodes.map((n) => (
              <Grid item xs={12} sm={6} md={4} key={n.node_id}>
                <NodeCard
                  node={n}
                  selected={selectedNodeId === n.node_id}
                  onSelect={() => onSelectNode(n)}
                  onSelectSession={onSelectSession}
                  selectedSession={selectedSession}
                  drawerOpen={drawerOpen}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Collapse>
    </Paper>
  );
};

export default NodeTypeSection;
